import { useEffect as e, useRef as t, useState as n } from "react";
import { useTranslation as r } from "react-i18next";
import { createInstance as i } from "i18next";
import { TZDate as a } from "@date-fns/tz";
import { addDays as o, getDay as s, isAfter as c } from "date-fns";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/constants.ts
var d = "feature-trading-session-alert", f = {
	close: "يغلق خلال",
	london: "لندن",
	newYork: "نيويورك",
	open: "يفتح خلال",
	tokyo: "طوكيو"
}, p = {
	close: "Schließt in",
	london: "London",
	newYork: "New York",
	open: "Öffnet in",
	tokyo: "Tokio"
}, m = {
	close: "Closes in",
	london: "London",
	newYork: "New York",
	open: "Opens in",
	tokyo: "Tokyo"
}, h = {
	close: "Cierra en",
	london: "Londres",
	newYork: "Nueva York",
	open: "Abre en",
	tokyo: "Tokio"
}, ee = {
	close: "Ferme dans",
	london: "Londres",
	newYork: "New York",
	open: "Ouvre dans",
	tokyo: "Tokyo"
}, g = {
	close: "Tutup dalam",
	london: "London",
	newYork: "New York",
	open: "Buka dalam",
	tokyo: "Tokyo"
}, _ = {
	close: "終了まで",
	london: "ロンドン",
	newYork: "ニューヨーク",
	open: "開始まで",
	tokyo: "東京"
}, v = {
	close: "마감까지",
	london: "런던",
	newYork: "뉴욕",
	open: "개장까지",
	tokyo: "도쿄"
}, y = {
	close: "Zamyka się za",
	london: "Londyn",
	newYork: "Nowy Jork",
	open: "Otwiera się za",
	tokyo: "Tokio"
}, b = {
	close: "Fecha em",
	london: "Londres",
	newYork: "Nova Iorque",
	open: "Abre em",
	tokyo: "Tóquio"
}, x = {
	close: "Закрытие через",
	london: "Лондон",
	newYork: "Нью-Йорк",
	open: "Открытие через",
	tokyo: "Токио"
}, S = {
	close: "ปิดใน",
	london: "ลอนดอน",
	newYork: "นิวยอร์ก",
	open: "เปิดใน",
	tokyo: "โตเกียว"
}, te = {
	close: "Kapanışa",
	london: "Londra",
	newYork: "New York",
	open: "Açılışa",
	tokyo: "Tokyo"
}, ne = {
	close: "Đóng cửa sau",
	london: "Luân Đôn",
	newYork: "New York",
	open: "Mở cửa sau",
	tokyo: "Tokyo"
}, re = {
	close: "距收盘",
	london: "伦敦",
	newYork: "纽约",
	open: "距开盘",
	tokyo: "东京"
}, C = d, ie = {
	"ar-SA": { [C]: f },
	"de-DE": { [C]: p },
	"en-GB": { [C]: m },
	"es-ES": { [C]: h },
	"fr-FR": { [C]: ee },
	"id-ID": { [C]: g },
	"ja-JP": { [C]: _ },
	"ko-KR": { [C]: v },
	"pl-PL": { [C]: y },
	"pt-PT": { [C]: b },
	"ru-RU": { [C]: x },
	"th-TH": { [C]: S },
	"tr-TR": { [C]: te },
	"vi-VN": { [C]: ne },
	"zh-CN": { [C]: re }
}, w = i();
w.init({
	debug: !1,
	resources: ie,
	ns: [C],
	defaultNS: C,
	load: "currentOnly",
	fallbackLng: "en-GB",
	interpolation: { escapeValue: !1 }
});
//#endregion
//#region src/lib/sub/defaults.ts
var T = [
	"monday",
	"tuesday",
	"wednesday",
	"thursday",
	"friday"
], ae = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"28px\" viewBox=\"0 -960 960 960\" width=\"28px\" fill=\"currentColor\"><path d=\"M440-120v-160H240v-80h200v-80H240v-80h163L200-840h95l185 292 185-292h95L557-520h163v80H520v80h200v80H520v160h-80Z\"/></svg>", oe = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"28px\" viewBox=\"0 -960 960 960\" width=\"28px\" fill=\"currentColor\"><path d=\"M240-120v-80l16.5-10q16.5-10 36-29.5t35.5-50q16-30.5 16-70.5 0-11-1.5-21t-3.5-19h-99v-80h60q-21-33-40.5-69.5T240-640q0-92 64-156t156-64q71 0 126 39t79 101l-74 31q-15-40-50.5-65.5T460-780q-58 0-99 41t-41 99q0 48 24 80t49 80h167v80H421q2 9 2.5 19t.5 21q0 50-17.5 90T364-200h196q40 0 61-21t29-54l70 35q-11 55-56.5 87.5T560-120H240Z\"/></svg>", se = "<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"28px\" viewBox=\"0 -960 960 960\" width=\"28px\" fill=\"currentColor\"><path d=\"M441-120v-86q-53-12-91.5-46T293-348l74-30q15 48 44.5 73t77.5 25q41 0 69.5-18.5T587-356q0-35-22-55.5T463-458q-86-27-118-64.5T313-614q0-65 42-101t86-41v-84h80v84q50 8 82.5 36.5T651-650l-74 32q-12-32-34-48t-60-16q-44 0-67 19.5T393-614q0 33 30 52t104 40q69 20 104.5 63.5T667-358q0 71-42 108t-104 46v84h-80Z\"/></svg>", ce = (e) => [
	{
		name: e("tokyo"),
		icon: ae,
		timeZone: "Asia/Tokyo",
		days: T,
		open: {
			hour: 9,
			minute: 0
		},
		close: {
			hour: 15,
			minute: 30
		}
	},
	{
		name: e("london"),
		icon: oe,
		timeZone: "Europe/London",
		days: T,
		open: {
			hour: 8,
			minute: 0
		},
		close: {
			hour: 16,
			minute: 30
		}
	},
	{
		name: e("newYork"),
		icon: se,
		timeZone: "America/New_York",
		days: T,
		open: {
			hour: 9,
			minute: 30
		},
		close: {
			hour: 16,
			minute: 0
		}
	}
], le = {
	sunday: 0,
	monday: 1,
	tuesday: 2,
	wednesday: 3,
	thursday: 4,
	friday: 5,
	saturday: 6
};
function ue(e, t) {
	let n = E(t);
	for (let r of e.markets) for (let { open: i, close: a } of de(r, t)) {
		if (n >= i - e.showOpenAlertBeforeMinutes * 60 && n < i) return {
			market: r,
			event: "open",
			at: i
		};
		if (n >= a - e.showCloseAlertBeforeMinutes * 60 && n < a) return {
			market: r,
			event: "close",
			at: a
		};
	}
	return null;
}
function E(e) {
	return Math.floor(e.getTime() / 1e3);
}
function de(e, t) {
	let n = new a(t, e.timeZone);
	return [
		-1,
		0,
		1
	].map((e) => o(n, e)).filter((t) => e.days.some((e) => le[e] === s(t))).map((t) => {
		let n = D(t, e.open), r = D(t, e.close), i = c(r, n) ? r : o(r, 1);
		return {
			open: E(n),
			close: E(i)
		};
	});
}
function D(e, t) {
	return new a(e.getFullYear(), e.getMonth(), e.getDate(), t.hour, t.minute, 0, 0, e.timeZone);
}
//#endregion
//#region src/lib/TradingSessionAlert.tsx
var O = "oklch(0.696 0.17 162.48)", k = "oklch(0.637 0.237 25.331)", fe = "#ffffff", pe = "oklch(0.141 0.005 285.823)", me = "oklch(0.141 0.005 285.823)", he = "oklch(0.967 0.001 286.375)", A = "2px", j = "solid", M = "12px", ge = "oklch(0.92 0.004 286.32)", _e = "oklch(0.37 0.013 285.805)", N = "6px 3px 6px 12px", P = "200px", F = "default", I = "border-box", L = "none", R = "18px", z = "6px", B = "hidden", V = "ellipsis", H = "nowrap", U = "13px", W = "uppercase", G = "700", K = "22px", q = "uppercase", J = "600", Y = "75px", X = "1px";
function Z(e) {
	return {
		backgroundColor: e === "light" ? fe : pe,
		textColor: e === "light" ? me : he,
		borderColor: e === "light" ? ge : _e
	};
}
function ve(i) {
	let { t: a } = r(d), o = $(i, a), s = t(null), [c, f] = n(""), [p, m] = n(""), [h, ee] = n(!1), [g, _] = n(""), [v, y] = n("");
	e(() => {
		s.current &&= (clearInterval(s.current), null);
		let e = () => {
			let e = Q(o, a);
			f(e.valueMarketName), m(e.valueStatus), ee(e.isOpen), _(e.valueTime), y(e.valueIcon);
		};
		return e(), s.current = setInterval(e, 1e3), () => {
			s.current && clearInterval(s.current), s.current = null;
		};
	}, [
		o.locale,
		o.theme,
		a
	]);
	let { backgroundColor: b, textColor: x, borderColor: S } = Z(o.theme);
	return !c || !p || !g ? null : /* @__PURE__ */ u("div", {
		style: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			backgroundColor: b,
			color: x,
			borderRadius: M,
			padding: N,
			minWidth: P,
			cursor: F,
			boxSizing: I,
			borderWidth: A,
			borderColor: S,
			borderStyle: j,
			userSelect: L,
			gap: R
		},
		children: [/* @__PURE__ */ u("div", {
			style: {
				display: "flex",
				alignItems: "center",
				gap: z
			},
			children: [/* @__PURE__ */ l("span", {
				style: {
					color: h ? O : k,
					display: "flex"
				},
				dangerouslySetInnerHTML: { __html: v }
			}), /* @__PURE__ */ u("div", {
				style: {
					lineHeight: "18px",
					overflow: B,
					textOverflow: V,
					whiteSpace: H
				},
				children: [/* @__PURE__ */ l("div", {
					style: {
						fontSize: U,
						textTransform: W,
						fontWeight: G
					},
					children: c
				}), /* @__PURE__ */ l("div", {
					style: {
						fontSize: U,
						textTransform: W,
						fontWeight: G
					},
					children: /* @__PURE__ */ l("span", {
						style: { color: h ? O : k },
						children: p
					})
				})]
			})]
		}), /* @__PURE__ */ l("div", {
			style: {
				display: "flex",
				alignItems: "center"
			},
			children: /* @__PURE__ */ l("p", {
				style: {
					fontSize: K,
					textTransform: q,
					fontWeight: J,
					width: Y,
					letterSpacing: X,
					margin: 0
				},
				children: g
			})
		})]
	});
}
function ye(e) {
	let t = be(e.locale), n = $(e, t), r = null, i = null, a = null, o = document.createElement("div"), s = null, c = () => {
		let { backgroundColor: e, textColor: t, borderColor: r } = Z(n.theme), i = document.createElement("div");
		i.style.display = "flex", i.style.alignItems = "center", i.style.justifyContent = "space-between", i.style.backgroundColor = e, i.style.color = t, i.style.borderRadius = M, i.style.padding = N, i.style.minWidth = P, i.style.cursor = F, i.style.boxSizing = I, i.style.borderWidth = A, i.style.borderStyle = j, i.style.borderColor = r, i.style.userSelect = L, i.style.gap = R;
		let a = document.createElement("div");
		a.style.display = "flex", a.style.alignItems = "center", a.style.gap = z;
		let o = document.createElement("span");
		o.style.display = "flex";
		let s = document.createElement("div");
		s.style.overflow = B, s.style.textOverflow = V, s.style.whiteSpace = H;
		let c = document.createElement("div");
		c.style.fontSize = U, c.style.textTransform = W, c.style.fontWeight = G;
		let l = document.createElement("div");
		l.style.fontSize = U, l.style.textTransform = W, l.style.fontWeight = G;
		let u = document.createElement("span");
		l.appendChild(u), s.appendChild(c), s.appendChild(l), a.appendChild(o), a.appendChild(s);
		let d = document.createElement("div");
		d.style.display = "flex", d.style.alignItems = "center";
		let f = document.createElement("p");
		return f.style.fontSize = K, f.style.textTransform = q, f.style.fontWeight = J, f.style.width = Y, f.style.letterSpacing = X, f.style.margin = "0", d.appendChild(f), i.appendChild(a), i.appendChild(d), i.iconSpan = o, i.marketNameDiv = c, i.statusSpan = u, i.timeP = f, i;
	}, l = () => {
		let { valueMarketName: e, valueStatus: r, isOpen: i, valueTime: a, valueIcon: l } = Q(n, t);
		if (e && r && a) {
			s || (s = c(), o.appendChild(s));
			let t = i ? O : k, n = s, u = n.iconSpan, d = n.marketNameDiv, f = n.statusSpan, p = n.timeP;
			u.style.color = t, u.innerHTML = l, f.style.color = t, d.textContent = e, f.textContent = r, p.textContent = a, s.style.display = "flex";
		} else s &&= (o.removeChild(s), null);
	}, u = () => {
		r !== null && clearInterval(r), l(), r = setInterval(l, 1e3);
	}, d = () => {
		r !== null && (clearInterval(r), r = null), i !== null && (i.disconnect(), i = null), a !== null && (clearTimeout(a), a = null);
	};
	return u(), i = new MutationObserver((e) => {
		e.forEach((e) => {
			e.removedNodes.forEach((e) => {
				e === o && d();
			});
		});
	}), a = setTimeout(() => {
		o.parentNode && i !== null && i.observe(o.parentNode, { childList: !0 });
	}), o.updateLocaleAndTheme = (e) => {
		let r = n;
		t = be(e.locale ?? r.locale), n = $({
			...r,
			...e
		}, t);
		let i = r.theme !== n.theme, a = r.locale !== n.locale;
		if (i && s) {
			let { backgroundColor: e, textColor: t, borderColor: r } = Z(n.theme);
			s.style.backgroundColor = e, s.style.color = t, s.style.borderColor = r;
		}
		(i || a) && l();
	}, o;
}
function Q(e, t) {
	let n = /* @__PURE__ */ new Date(), r = ue(e, n);
	if (r === null) return {
		valueMarketName: "",
		valueStatus: "",
		isOpen: !1,
		valueTime: "",
		valueIcon: ""
	};
	let i = r.event === "open";
	return {
		valueMarketName: r.market.name,
		valueStatus: t(i ? "open" : "close"),
		isOpen: i,
		valueTime: a(r.at, E(n)),
		valueIcon: r.market.icon
	};
	function a(e, t) {
		let n = e - t;
		if (n < 60) return `00:${n < 10 ? "0" : ""}${n}`;
		let r = Math.floor(n / 60), i = n % 60;
		return `${r < 10 ? "0" : ""}${r}:${i < 10 ? "0" : ""}${i}`;
	}
}
function $(e, t) {
	return {
		markets: e.markets ?? ce(t),
		showOpenAlertBeforeMinutes: e.showOpenAlertBeforeMinutes ?? 5,
		showCloseAlertBeforeMinutes: e.showCloseAlertBeforeMinutes ?? 5,
		locale: e.locale ?? "en-GB",
		theme: e.theme ?? "light"
	};
}
function be(e) {
	let t = e ?? "en-GB";
	return w.language !== t && w.changeLanguage(t), w.getFixedT(null, d);
}
//#endregion
export { d as FEATURE_TRADING_SESSION_ALERT_NAMESPACE, ye as TradingSessionAlertDOM, ve as TradingSessionAlertTSX };
